import { populatedCampaignSchema } from "@redotech/redo-marketing-common/campaigns/campaign-definition";
import * as z from "zod/v4";

export const addABTestVariant = {
  name: "addABTestVariant" as const,
  input: z.object({ campaignId: z.string() }),
  output: populatedCampaignSchema,
};
